import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { getPartyPayDataByMgLog } from "../../../../AdminApi/commFunc";
import { GetMoneyValue } from "../../../../Api/ApiCommon";
import { useApi } from "../../../../hooks/useApi";
import Pagination from "../../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import { useRecoilValue } from "recoil";
import { authType } from "../../../../pages/Login";
import LineBox from "../../../DefaultStyles/LineBox";
import TitleWithLine from "../../../DefaultStyles/TitleWithLine";
import Blank from "../../../DefaultStyles/Blank";
import PartyDetailPayInfoFilter from "./PartyDetailPayInfo/PartyDetailPayInfoFilter";
import { toast } from "react-toastify";
import Loader from "../../../DefaultStyles/Loader";
import { useNavigate } from "react-router-dom";
import SpaceBetween from "../../../DefaultStyles/SpaceBetween";
import Flex from "../../../DefaultStyles/Flex";
import ToggleBtn from "../../../Button/ToggleBtn";
import { ChatType } from "../ChatInfo/ChatSearch/RecentChat/RecentChatHeader";

interface PartyDetailPayInfoProps {
  partyId?: string;
  owner?: string;
}

interface IPartyPayInfo {
  uid: string;
  name: string;
  nickname: string;
  calc_date: string;
  details: string;
  enfo_date: string;
  val: number;
  type: string;
  reason: string;
}

export default function PartyDetailPayInfo({
  partyId,
  owner,
}: PartyDetailPayInfoProps) {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [isNewVersion, setIsNewVersion] = useState(true);
  const [filteringValue, setFilteringValue] = useState({
    uid: "",
  });

  const { response, error, loading } = useApi({
    method: "get",
    url: auth?.partyInfo
      ? `party/${partyId}/pay?page=${page}&size=5&version=${
          isNewVersion ? 3 : 2
        }` + (filteringValue?.uid !== "" ? `&uid=${filteringValue?.uid}` : "")
      : undefined,
  });

  const partyInfoHeader = [
    "UID_이름_닉네임",
    "등급",
    "적요",
    "mglog_details",
    "금액",
    "로그 시간",
    "적립 예정 일시",
    "적립 대상",
  ];

  useEffect(() => {
    if (error) {
      toast.error(error.data);
    }
  }, [error]);

  return (
    <>
      <PartyDetailPayInfoFilter
        setFilteringValue={setFilteringValue}
        list={response?.data?.items[0]?.payLog?.length}
      />

      <LineBox>
        <>
          <SpaceBetween>
            <TitleWithLine title="결제/적립 정보" />

            <Flex gapSize={8}>
              <ToggleBtn
                check={isNewVersion}
                checkEvent={() => setIsNewVersion((prev) => !prev)}
              />

              <ChatType isFirebase={!isNewVersion}>
                {isNewVersion ? "버전 3" : "버전 2"}
              </ChatType>
            </Flex>
          </SpaceBetween>

          <Blank blankHeight={24} />

          <Table tableHeadData={partyInfoHeader} tableMinWidth={935}>
            <>
              {response?.data?.items[0]?.payLog?.map(
                (d: IPartyPayInfo, index: number) => {
                  const mgLogData = getPartyPayDataByMgLog(
                    d?.type,
                    d?.details,
                    d?.reason,
                    +owner! === +d?.uid ? true : false
                  );

                  return (
                    <TableBody key={index}>
                      <TableBodyItem
                        clickable={true}
                        onClick={() => navigate(`/users/info/${d?.uid}`)}
                      >
                        {d?.uid}_{d?.name}_{d?.nickname}
                      </TableBodyItem>
                      <TableBodyItem>
                        {+d?.uid === 0
                          ? "-"
                          : +owner! === +d?.uid
                          ? "파티장"
                          : "파티원"}
                      </TableBodyItem>
                      <TableBodyItem>{mgLogData?.abstract}</TableBodyItem>
                      <TableBodyItem>
                        {d?.type}: {d?.details}
                      </TableBodyItem>
                      <TableBodyItem>{GetMoneyValue(d?.val)}</TableBodyItem>
                      <TableBodyItem>
                        {dayjs(d?.enfo_date)?.format("YYYY-MM-DD HH:mm")}
                      </TableBodyItem>
                      <TableBodyItem>
                        {dayjs(d?.calc_date)?.format("YYYY-MM-DD")}
                      </TableBodyItem>
                      <TableBodyItem>
                        {mgLogData?.addTo?.includes("/")
                          ? owner === d?.uid
                            ? "파티장"
                            : "파티원"
                          : mgLogData?.addTo}
                      </TableBodyItem>
                    </TableBody>
                  );
                }
              )}
            </>
          </Table>

          <Pagination
            totalPage={response?.status === 200 ? response?.data?.totalPage : 3}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          {loading && <Loader />}
        </>
      </LineBox>
    </>
  );
}
